/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Point_HonestyInputs */

const en_directory_hubs_signals_geo_point_honesty = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_HonestyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO does not replace classic SEO — it compounds with it. Pages that rank well and score well get cited by both humans and machines.`)
};

const zh_directory_hubs_signals_geo_point_honesty = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_HonestyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO 不取代经典 SEO——而是与之叠加。排名好且 GEO 好的页面，会同时被人类和机器引用。`)
};

/**
* | output |
* | --- |
* | "GEO does not replace classic SEO — it compounds with it. Pages that rank well and score well get cited by both humans and machines." |
*
* @param {Directory_Hubs_Signals_Geo_Point_HonestyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_point_honesty = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Point_HonestyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Point_HonestyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_point_honesty(inputs)
	return zh_directory_hubs_signals_geo_point_honesty(inputs)
});
export { directory_hubs_signals_geo_point_honesty as "directory.hubs.signals.geo.point.honesty" }